import { base64EncodeUnicode } from '@/utils/base64'

// Search results
export const CHOICES = [
  {
    id: 'com.ptc.windchill.option.model.Choice.649652314',
    id2: '0P3B1',
    name: '4x2',
    optionId: 'com.ptc.windchill.option.model.Group.2292057920',
    optionId2: '0KHV'
  },
  {
    id: 'com.ptc.windchill.option.model.Choice.649646039',
    id2: '0P3BE',
    name: '6x6H',
    optionId: 'com.ptc.windchill.option.model.Group.2292057920',
    optionId2: '0KHV'
  },
  {
    id: 'com.ptc.windchill.option.model.Choice.649659859',
    id2: '0P3BM',
    name: '8x6',
    optionId: 'com.ptc.windchill.option.model.Group.2292057920',
    optionId2: '0KHV'
  }
]
export const COMPONENT_VARIANTS = [
  { id: '0001944677', id2: '51.#00TF-0009', name: 'Vorbereitung', componentId2: '00TF', componentId: '0000000017' },
  { id: '0001944677', id2: '51.#00TF-0008', name: 'Vorbereitung 2', componentId2: '00TT', componentId: '0000000018' }
]
export const COMPONENTS = [
  { id: '0000000017', id2: '00TF', name: 'Generator', componentVariants: COMPONENT_VARIANTS },
  { id: '0000000239', id2: '00TL', name: 'Abgasschalldämpfer', componentVariants: [] }
]
export const OPTIONS = [
  {
    id: 'com.ptc.windchill.option.model.Group.2292057920',
    id2: '0KHV',
    name: 'Funktionspaket Bremse für Branchenanwendung ',
    categoryName: 'Horizontal - und Vertikallasten',
    choices: CHOICES
  },
  {
    id: 'com.ptc.windchill.option.model.Group.2292057988',
    id2: '0KH3',
    name: 'Lastvariante Horizontal Zuordnung Tech. Plus ',
    categoryName: 'Druckluftbremsen, Drucklufterzeugung, Bremssystem',
    choices: []
  }
]

export const SEARCH_RESULTS = [...OPTIONS, ...COMPONENTS]

// Elements ids maps
const optionsMap = new Map()
const componentsMap = new Map()

OPTIONS.forEach(({ id, choices }) => optionsMap.set(id, choices.map(choice => choice.id)))
COMPONENTS.forEach(({ id, componentVariants }) => componentsMap.set(id, componentVariants.map(kv => kv.id)))

export const OPTIONS_IDS_MAP = optionsMap
export const COMPONENTS_IDS_MAP = componentsMap

// Search input field
export const SEARCH_STRING = '00TL; 0KHN; T001'
export const FORMATTED_SEARCH_STRING = SEARCH_STRING.split(';').map(item => base64EncodeUnicode(item.trim())).join(',')

// Summary
export const SUMMARY = {
  id: 9999,
  components: COMPONENTS,
  creator: 'z9876',
  currentSelection: true,
  name: 'z9876_CurrentSelection',
  options: OPTIONS,
  pmEncodedBusinessName: 'RnJlaWdhYmUgU2VyaWU',
  collection: null,
  productModelId: '123'
}

export const COLLECTION_STATUS_LABEL = {
  VIEWING: { key: 'VIEWING', label: 'Viewing' },
  CHANGED: { key: 'CHANGED', label: 'Changed' },
  UPDATED: { key: 'UPDATED', label: 'Updated' }
}
export const SELECTED_ELEMENTS = {
  options: [],
  components: []
}

export const SELECTED_ELEMENTS_DATA = { options: OPTIONS, components: COMPONENTS }
